import { AfterContentInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from './services/app.service';
import { Subscription } from 'rxjs';
import { ApiService } from './services/api.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, AfterContentInit, OnDestroy {

  //-- VARIABLES -------------------------------------------------------|

  activeMenu: boolean = false;
  lazyloading: boolean = true;
  
  @ViewChild('zoneContainer', {static: false}) container: ElementRef;

  private $lazyLoading: Subscription;

  //-- CONSTRUCTOR -----------------------------------------------------|

  constructor(translate: TranslateService, private appService: AppService, private apiService: ApiService) {
    translate.setDefaultLang('en');
    translate.use('en');
    this.$lazyLoading = this.apiService.$lazyLoading.subscribe(data => this.lazyloading = data);
  }

  //-- EVENTS ----------------------------------------------------------|

  onActivate() {
    this.container.nativeElement.scrollTo(0, 0);
  }

  //-- INITIALIZE ------------------------------------------------------|

  ngOnInit() {
    
  }
  
  ngAfterContentInit() {
    this.apiService.isAuthenticated().subscribe(() => {
      this.apiService.offer();
    });
  }

  //-- DESTORY ---------------------------------------------------------|

  ngOnDestroy() {
    if (this.$lazyLoading) { this.$lazyLoading.unsubscribe(); }
  }

  //--------------------------------------------------------------------|

}
